<!--
* UI Name: Recent Transactions
* Modify Date: 2021.12.27
-->
<template>
  <div class="pa-4 custome-border-component fixed-height-comp">
    <!-- Header -->
    <v-row class="page-header mt-0">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold custom-title">{{ $t("lbl.admin.recent_trans") }}</v-toolbar-title>
      </v-col>
    </v-row>

    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :class="['list-table admin-process-style srm-list-table custom-border-table', listData.length > 0 ? '' : 'custom-border-table-not-data']"
          :fixed-header="true"
          hide-default-footer
          :height="tableHeight"
          disable-pagination
          disable-sort
        >
          <template v-slot:item.errorMessage="{ item }">
            <span>
              <font
                :color="statusColor_list(item.transactionCode, item.errorMessage)"
              >{{item.errorMessage}}</font>
            </span>
          </template>
          <template v-slot:item.timestamp="{ item }">
            <font>{{applyGmtTimeZone(item.timestamp)}}</font>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import $ from "jquery";
import { resizeTableHeight } from "@/vue-dlb/common/common";
import { mapState } from "vuex";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
const moment = require("moment");

export default {
  components: {
    SystemProgress,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("lbl.admin.owner_header"),
          value: "groupId",
          width: "150px",
        },
        {
          text: this.$t("lbl.admin.company_header"),
          value: "userId",
          width: "150px",
        },
        {
          text: this.$t("lbl.admin.process_header"),
          value: "processId",
          width: "180px",
        },
        {
          text: this.$t("lbl.admin.transaction"),
          value: "transactionCode",
          width: "130px",
        },
        {
          text: this.$t("lbl.admin.errorRecent"),
          value: "errorMessage",
          align: "center",
          width: "auto",
        },
        {
          text: this.$t("lbl.admin.dateTime"),
          value: "timestamp",
          align: "center",
          width: "160px",
        },
      ],
      listData: [],
      isCreated: false,
      tableHeight: "",
      isLoading: false,
    };
  },

  computed: {
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
  },

  watch: {},

  created() {
    this.isCreated = true;
    this.searchData();
  },
  updated: function () {
    let self = this;
    let arrClassMinus = [".page-control-content"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 285 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 285 + "px";
    });
  },
  mounted() {},

  methods: {
    applyGmtTimeZone(date) {
      let newM = "";
      if (date !== undefined && date !== "") {
        newM = moment
          .utc(date)
          .add(this.$cookies.get("gmt-timezone"), "hours")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },
    statusColor_list(status, errMsg) {
      if (status !== undefined) {
        if (
          status.indexOf("DONE") !== -1 &&
          (errMsg === undefined || errMsg === "")
        )
          return "#2a8c72";
        else if (
          status.indexOf("FAIL") !== -1 ||
          (errMsg !== undefined && errMsg !== "")
        )
          return "#EB1E50";
        else if (status.indexOf(undefined) !== -1) return "#EB1E50";
        else return "#6F5ECE";
      }
    },

    searchData() {
      this.isLoading = true;
      const params = {
        ownrId : this.$cookies.get("ownr-id")
      }
      this.$store
        .dispatch("getRecentTransactionList", params)
        .then(() => {
          this.listData = this.$store.getters.recentTransData;
          console.log(this.listData);
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
  },
};
</script>